import React from "react";
import { dispatch } from '@rematch/core';
import convertIcon from "../../../../../../helpers/convert-Icon";
import EllipsisTooltip from "../../../../../common/EllipsisTooltip";
import { Tab, Label, Menu, Message, Segment, Header, Icon, Checkbox, Image, Popup } from "semantic-ui-react";
import dummyAvatar from '../../../../../../images/common/jenny.jpg';
import AttachmentImage from '../../../../../../images/menu-icons/user/icon-community.svg';
import ErrorMessage from '../summaryTabs/ErrorMessage'
import NoSummaryData from '../summaryTabs/NoSummaryDataPage'
import PlaceholderCardImage from './../../../../../drive/PlaceHolder/PlaceHolderLines'
import { toastr } from 'react-redux-toastr';

class AttachmentTabs extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeIndex: 0,
        }
    }

    isAuthor = () => {
        const loggdinUserId = this.props.user.email;
        let author =
          this.props.selectedPracticeLibrary &&
          this.props.selectedPracticeLibrary.participants &&
          this.props.selectedPracticeLibrary.participants.filter((participant) => {
            return participant.role === "author";
          });
        if (author && author.length > 0) {
          return author.find((author) => author.email === loggdinUserId);
        }
        return null;
      };

       isContributor = () => {
        const loggdinUserId = this.props.user.email;
        let contributor =
          this.props.selectedPracticeLibrary &&
          this.props.selectedPracticeLibrary.participants &&
          this.props.selectedPracticeLibrary.participants.filter((participant) => {
            return participant.role === "contributor";
          });
        if (contributor && contributor.length > 0) {
          return contributor.find((contributor) => contributor.email === loggdinUserId);
        }
        return null;
      };
      isWorkspaceOwner = () => {
        let authors =
          this.props.currentOrganization &&
          this.props.currentOrganization.users &&
          this.props.currentOrganization.users.filter(
            (el) =>
              el.accountUserId === this.props.user._id &&
              el.role === "workspaceOwner"
          );
        if (authors && authors.length > 0) {
          return true;
        }
        return null;
      };

    onTabChange = (event, data) => {
        this.setState({ activeIndex: data.activeIndex })
    }

    viewLink = (e, attachment) => {
        if (e) {
            e.stopPropagation()
        }
        if(attachment.documentUrl){
            let redirectUrl = attachment.documentUrl.indexOf('://') === -1 ? 'http://' + attachment.documentUrl : attachment.documentUrl;
            window.open(redirectUrl, '_blank');
        } else {
            attachment.accountId = this.props.match.params.accountId;
            dispatch.app.downloadAttachment(attachment);
        }
    }

    handleAttachmentDelete = (e, attachment, activity, index, index2) => {
        e.stopPropagation();
        attachment.resourceId = activity._id;
        attachment.entityName = "activity";
        let message = <div className="confirmMessage">
            <h3>Delete Attachment</h3>
            <label>{attachment.documentName}</label>
            <p>Are you sure to delete this Attachment?</p>
            <span >This action is not reversible.</span>
        </div>
        toastr.confirm(message, {
            onOk: async () => {
                await dispatch.app.deleteAttachment(attachment);
                let payload = {
                    id: this.props.match.params.playbookId
                }
                dispatch.lifeCycle.getActivitySummary(payload)
            }
        });
    }

    handleDistinctAttachmentDelete = (e,attachment)=>{
        e.stopPropagation();
        let message = <div className="confirmMessage">
            <h3>Delete Attachment</h3>
            <label>{attachment.documentName}</label>
            <p>Are you sure to delete this Attachment from all activities?</p>
            <span >This action is not reversible.</span>
        </div>
        toastr.confirm(message, {
            onOk: async () => {
                if(this.props.attachmentsData){
                    for (const task of this.props.attachmentsData) {
                        for (const att of task.attachments) {
                        const selectedAttachMentKey = `${attachment.documentName}-${attachment.documentUrl}`;
                        const key = `${att.documentName}-${att.documentUrl}`
                        if (selectedAttachMentKey === key) {
                            att.resourceId = task._id;
                            att.entityName = "activity";
                            await dispatch.app.deleteAttachment(att);
                        }
                        }
                    }
                }
                let payload = {
                    id: this.props.match.params.playbookId
                }
                dispatch.lifeCycle.getActivitySummary(payload)
            }
        });
    }
    getIcon = (document) => {
        let extension = document.split('.').pop().toUpperCase()
        const documentTypes = ['PDF', 'DOC', 'DOCX', 'PPT', 'PPTX', 'XLS', 'XLSX', 'EPUB', 'ODT', 'ODP', 'ODS', 'TXT', 'RTF'];
        const imageTypes = ['BMP', 'PNG', 'JPG', 'JPEG', 'GIF', 'SVG', 'TIFF', 'EPS'];
        const audioTypes = ['WAV', 'MP3', 'WMA', 'FLAC', 'ALAC', 'PCM', 'AIFF', 'ACC', 'OGG'];
        const videoTypes = ['MPG', 'MPEG', 'MOV', 'MP4', 'AVI', 'WMV', 'FLV', 'SWF', 'WEBM', 'MPE', 'MPV', 'MP2', 'OGG', 'mp4', 'M4V', 'QT'];
        const zipTypes = ['ZIP', 'CAB', 'BIN', 'JAR', 'TAR', 'WAR', 'RAR', '7Z', 'GZ'];

        if (documentTypes.includes(extension)) {
            return 'file alternate'
        }
        if (imageTypes.includes(extension)) {
            return 'image'
        }
        if (audioTypes.includes(extension)) {
            return 'microphone'
        }
        if (videoTypes.includes(extension)) {
            return 'video'
        }
        if (zipTypes.includes(extension)) {
            return 'file archive'
        }
        return 'file';
    }

    render() {
        const { loadingActivitySummary } = this.props
        let contentErrorList = <div>
            {this.props.attachmentsData && this.props.attachmentsData.map((m, i) => {
                return <Segment.Group
                    key={i}
                    size="small"
                    className={`tabContent `}>
                    <Header as='h6' attached='top'>
                        <EllipsisTooltip name={m.name} />
                    </Header>
                    {m.attachments.map((cont, i2) => {
                        return <Segment
                            id={cont._id + "_cont"}
                            key={i2}
                            className={`${this.state._id === cont._id ? 'active' : ""}`}
                            style={{ height: "38px", padding: "10px 15px" }}>
                            <div
                                className="float-left"
                                style={{ width: "calc(100% - 310px)" }}>
                                <Popup
                                    className="popupStyled"
                                    inverted
                                    trigger={
                                        <Icon
                                            name={this.getIcon(cont.documentName)}
                                            onClick={(e) => this.viewLink(e, cont, m)}
                                            className="f_14 float-left text-left"
                                            style={{ width: "20px", color: "#4183c4" }}
                                        />
                                    }
                                    content={cont.documentUrl ? 'view' : 'download'}
                                    position='top center'
                                /> &nbsp;
                                <p
                                    className="float-left"
                                    style={{ width: "calc(100% - 30px)" }}
                                >
                                    <EllipsisTooltip name={cont.documentName} />
                                </p>

                            </div>
                            <div className="float-right text-right" style={{ width: "280px" }}>
                                {this.props.selectedPracticeLibrary.status === 0 || (this.props.selectedPracticeLibrary.status === 4 && (this.isAuthor() || this.isWorkspaceOwner() || this.isContributor())) ?
                                     <Popup
                                    className="popupStyled"
                                    inverted
                                    trigger={
                                        <Icon
                                            className="clr-orange"
                                            name="trash alternate"
                                            onClick={(e, data) => this.handleAttachmentDelete(e, cont, m, i, i2)} />
                                    }
                                    content="Delete"
                                /> : null
                                }
                               
                            </div>
                        </Segment>
                    })}
                </Segment.Group>
            })}
        </div>
        let uniqueContentErrorList = <div><Segment.Group size="small"
        className={`tabContent `}>
        {this.props.uniqueAttachments && this.props.uniqueAttachments.map((cont, i) => {
                    return <Segment
                        id={cont._id + "_cont"}
                        key={i}
                        className={`${this.state._id === cont._id ? 'active' : ""}`}
                        style={{ height: "38px", padding: "10px 15px" }}>
                        <div
                            className="float-left"
                            style={{ width: "calc(100% - 310px)" }}>
                            <Popup
                                className="popupStyled"
                                inverted
                                trigger={
                                    <Icon
                                        name={this.getIcon(cont.documentName)}
                                        onClick={(e) => this.viewLink(e, cont)}
                                        className="f_14 float-left text-left"
                                        style={{ width: "20px", color: "#4183c4" }}
                                    />
                                }
                                content={cont.documentUrl ? 'view' : 'download'}
                                position='top center'
                            /> &nbsp;
                            <p
                                className="float-left"
                                style={{ width: "calc(100% - 30px)" }}
                            >
                                <EllipsisTooltip name={cont.documentName} />
                            </p>

                        </div>
                        <div className="float-right text-right" style={{ width: "280px" }}>
                            {this.props.selectedPracticeLibrary.status === 0 || (this.props.selectedPracticeLibrary.status === 4 && (this.isAuthor() || this.isWorkspaceOwner() || this.isContributor())) ?
                                 <Popup
                                className="popupStyled"
                                inverted
                                trigger={
                                    <Icon
                                        className="clr-orange"
                                        name="trash alternate"
                                         onClick={(e, data) => this.handleDistinctAttachmentDelete(e, cont, i)} 
                                    />
                                }
                                content="Delete"
                            /> : null
                            }                         
                        </div>
                    </Segment>
                })}</Segment.Group>
    </div>
        const panes = [
            {
                menuItem:
                    <Menu.Item key='All'>
                        All <Label>{this.props.totalAttachment}</Label>
                    </Menu.Item>,
                render: () => <Tab.Pane className="bg-light-blue">

                    {contentErrorList}
                </Tab.Pane>
            },
            {
                menuItem:
                    <Menu.Item key='Distinct'>
                        Distinct <Label>{this.props.uniqueAttachmentsCounts}</Label>
                    </Menu.Item>,
                render: () => <Tab.Pane className="bg-light-blue">

                    {uniqueContentErrorList}
                </Tab.Pane>
            }

        ]

        return (
            <div >
                <Tab
                    style={{ padding: 0 }}
                    panes={panes}
                    onTabChange={this.onTabChange}
                />
            </div>
        );
    }
}
export default AttachmentTabs;
